
import React, { useEffect, useState } from "react";

import {
  NavLink,
  useLocation,
  useNavigate
} from "react-router-dom";

import logo from "../assets/logo.png";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  // Close the mobile menu when the route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Preserve existing logout behavior
  const onLogoutClick = () => {
    setIsOpen(false);

    // PROFILE PAGE: show the existing logout popup
    if (location.pathname === "/profile") {
      window.dispatchEvent(new Event("app-logout"));
      return;
    }

    // OTHER PAGES: direct logout
    localStorage.removeItem("user");
    localStorage.removeItem("token");

    navigate("/");
  };

  // Normal active menu behavior
  const linkClass = ({ isActive }) =>
    isActive ? "menu-link active-left" : "menu-link";

  // Keep My Tickets highlighted on ticket-related pages
  // Keep My Tickets highlighted on ticket list, details and edit pages
const myTicketsClass = ({ isActive }) => {
  const path = location.pathname;

  const isTicketPage =
    path === "/my-tickets" ||
    /^\/ticket\/[^/]+(?:\/edit)?\/?$/.test(path);

  return isActive || isTicketPage
    ? "menu-link active-left"
    : "menu-link";
};

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      {/* Mobile header */}
      <header className="mobile-header">
        <button
          type="button"
          className={`sidebar-toggle ${isOpen ? "toggle-open" : ""}`}
          onClick={() => setIsOpen((previous) => !previous)}
          aria-label={isOpen ? "Close menu" : "Open menu"}
          aria-expanded={isOpen}
          aria-controls="rds-mobile-sidebar"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className="mobile-brand">
          <img src={logo} alt="" />
          <span>RDS HelpDesk</span>
        </div>
      </header>

      {/* Mobile overlay */}
      {isOpen && (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Close navigation menu"
          onClick={closeMenu}
        />
      )}

      {/* Sidebar */}
      <div
        id="rds-mobile-sidebar"
        className={`sidebar ${isOpen ? "sidebar-open" : ""}`}
      >
        <div className="logo-container">
          <img
            src={logo}
            alt="Logo"
            className="logo-img"
          />

          <div className="logo-text">
            RDS HelpDesk
          </div>
        </div>

        <nav className="menu" aria-label="Main navigation">
          <NavLink
            to="/userdashboard"
            className={linkClass}
            onClick={closeMenu}
          >
            Dashboard
          </NavLink>

          <NavLink
            to="/create-ticket"
            className={linkClass}
            onClick={closeMenu}
          >
            Create Ticket
          </NavLink>

          <NavLink
            to="/my-tickets"
            className={myTicketsClass}
            onClick={closeMenu}
          >
            My Tickets
          </NavLink>

          <NavLink
            to="/profile"
            className={linkClass}
            onClick={closeMenu}
          >
            Profile
          </NavLink>

          <button
            type="button"
            onClick={onLogoutClick}
            className="menu-link logout-link"
          >
            Logout
          </button>
        </nav>
      </div>
    </>
  );
}
